import { Deserializable } from '../../protocols/deserializable';

export class GradingResult implements Deserializable {
  grade: number;
  gradeDate: string;
  url: string;
  onDeserialize() {}
}
